const Product = {
    product: () => 'inventory/stocks/store/v2',
    view: () => 'store/product',
    filter: () => 'inventory/filters',
    productById: (id: string) => `store/product/${id}`,
    productDetailById: (id: string) => `inventory/stocks/store/v2/${id}`,
    productTypeList: () => `admin/common/product-type`,
    addToCart: () => 'store/cart/add',

    // Add Product
    addProduct: () => 'store/product',
    deleteProductById: (id: string) => `store/product/${id}`,
    productImages: () => `admin/product/images`,
    productShape: () => 'admin/common/product-shape',
    productMaterial: () => 'admin/common/product-material',
    productColor: () => 'admin/common/color-code',
    brand: () => 'store/brands-product-types',
    sizeDetails: () => 'admin/size-details',
    bulkUpload:()=>'store/product/bulk-upload',
    fetchProductsByModel:()=>'store/product/search',

    // for common brand filter
    getBrandList:()=>'store/common/brand',

    //make un_recognize product offline and online
    productOfflineOnline:(id:string)=> `store/product/${id}/ecommerce/status`

}
export default Product
